import React from "react";
import "../style/home.css";
import { Link } from "react-router-dom";
import { FaPhoneAlt } from "react-icons/fa";


// services images
import medicine from "../assets/internal-medicine.png";
import orthopedic from "../assets/orthopedics.png";
import general from "../assets/general-surgery-gopi.png";
import pediatric from "../assets/pedia.png";
import urology from "../assets/urology.png";
import gastrology from "../assets/gestrointestinal-medicine.png";


// TEAM IMAGES
import Doc from "../assets/docsumit.jpg";
// import Doc1 from "../assets/docchintan.jpg";
import Doc2 from "../assets/doc.jpg";

// HOSPITAL FEATURES IMAGES
import emergency from "../assets/emergency-service.png";
import licensed from "../assets/licenced-&-Insured.png";
import support from "../assets/available.png";
import bio from "../assets/bio-medical.png";

// PARTNER IMAGES
import Pic3 from "../assets/Picture3.png";
import Pic4 from "../assets/Picture4.png";
import Pic5 from "../assets/Picture5.png";
import Pic6 from "../assets/Picture6.png";
import Pic7 from "../assets/Picture7.png";
import Pic8 from "../assets/Picture8.png";
import Pic9 from "../assets/Picture9.png";
import Pic10 from "../assets/Picture10.png";
import Pic11 from "../assets/Picture11.png";
import Pic12 from "../assets/Picture12.png";
import Pic13 from "../assets/Picture13.png";
import Pic15 from "../assets/Picture15.png";
import Pic16 from "../assets/Picture16.png";
import Pic17 from "../assets/Picture17.png";
import Pic18 from "../assets/Picture18.png";
import Pic19 from "../assets/Picture19.png";
import Pic20 from "../assets/Picture20.png";
import Pic21 from "../assets/Picture21.png";
import Pic22 from "../assets/Picture22.png";
import Pic23 from "../assets/Picture23.png";
import Pic24 from "../assets/Picture24.png";
import Pic25 from "../assets/Picture25.png";
import Pic26 from "../assets/Picture26.png";
import Pic27 from "../assets/Picture27.png";
import Pic28 from "../assets/Picture28.png";
import Pic29 from "../assets/Picture29.png";
import Pic30 from "../assets/Picture30.png";
import Pic31 from "../assets/Picture31.png";
import Pic32 from "../assets/Picture32.png";
import Pic33 from "../assets/Picture33.png";
import Pic34 from "../assets/Picture34.png";
import Pic35 from "../assets/Picture35.png";
import Pic36 from "../assets/Picture36.png";
import Pic37 from "../assets/Picture37.png";
import Pic38 from "../assets/Picture38.png";
import Pic39 from "../assets/Picture39.png";
import Pic40 from "../assets/Picture40.png";
import Pic41 from "../assets/Picture41.png";
import Pic42 from "../assets/Picture42.png";
import Pic43 from "../assets/picture43.png";
import Pic44 from "../assets/Picture44.png";
import Pic45 from "../assets/Picture45.png";
import Pic46 from "../assets/Picture46.png";
import Pic47 from "../assets/Picture47.png";
import Pic48 from "../assets/Picture48.png";
import Pic49 from "../assets/Picture49.png";
import Pic50 from "../assets/Picture50.png";
import Pic51 from "../assets/Picture51.png";
import Pic52 from "../assets/Picture52.png";
import Pic53 from "../assets/Picture53.png";

const Home = () => {
  // Stats Section
  const statsData = [
    { count: "100", label: "Happy Patients" },
    { count: "6", label: "Expert Doctors" },
    { count: "25+", label: "Years Experience" },
    { count: "50+", label: "Departments" },
  ];

  // const servicesData = [
  //   { icon: "❤️", title: "Cardiology", desc: "Advanced heart care", link: "/" },
  //   { icon: "🧠", title: "Neurology", desc: "Expert neurological treatment", link: "/" },
  //   { icon: "🦴", title: "Orthopedics", desc: "Bone and joint care", link: "/" },
  //   { icon: "👶", title: "Pediatrics", desc: "Care for children", link: "/" },
  //   { icon: "🩺", title: "Physician", desc: "Diagnosis and treatment", link: "/" },
  //   { icon: "👨🏻‍⚕️", title: "General Surgery", desc: "Surgical specialists", link: "/" },
  // ];
  // const servicesData = [
  //   { img: medicine, title: "Medicine", link: "/services/medicine" },
  //   { img: orthopedic, title: "Orthopedic", link: "/services/orthopedic" },
  //   { img: general, title: "General Surgery", link: "/services/general-surgery" },
  //   { img: pediatric, title: "Pediatric", link: "/services/pediatric" },
  //   { img: urology, title: "Urology", link: "/services/urology" },
  //   { img: gastrology, title: "Gastrology", link: "/services/gastrology" },
  // ];
  const servicesData = [
    {
      img: medicine,
      title: "Medicine",
      desc: "Comprehensive internal medicine care",
      link: "/services/medicine"
    },
    {
      img: orthopedic,
      title: "Orthopedic",
      desc: "Bone & joint specialist treatment",
      link: "/services/orthopedic"
    },
    {
      img: general,
      title: "General Surgery",
      desc: "Advanced surgical procedures",
      link: "/services/general-surgery"
    },
    {
      img: pediatric,
      title: "Pediatric",
      desc: "Specialized child healthcare",
      link: "/services/pediatric"
    },
    {
      img: urology,
      title: "Urology",
      desc: "Urinary system & kidney care",
      link: "/services/urology"
    },
    {
      img: gastrology,
      title: "Gastrology",
      desc: "Digestive system treatment",
      link: "/services/gastrology"
    },
  ];


  const doctors = [
    { img: Doc2, name: "Dr. Neel Patel", role: "MD Physician" },
    { img: Doc2, name: "Dr. Darshak Patel", role: "Ortho. Surgeon" },
    { img: Doc2, name: "Dr. Purvesh Bhatt", role: "General Surgeon" },
    { img: Doc, name: "Dr. Sumit Patel", role: "Pediatrician" },
  ];

  // PARTNER IMAGES LIST
  const partnerImages = [
    Pic3, Pic4, Pic5, Pic6, Pic7, Pic8, Pic9, Pic10, Pic11, Pic12, Pic13,
    Pic15, Pic16, Pic17, Pic18, Pic19, Pic20, Pic21, Pic22, Pic23, Pic24,
    Pic25, Pic26, Pic27, Pic28, Pic29, Pic30, Pic31, Pic32, Pic33, Pic34,
    Pic35, Pic36, Pic37, Pic38, Pic39, Pic40, Pic41, Pic42, Pic43, Pic44,
    Pic45, Pic46, Pic47, Pic48, Pic49, Pic50, Pic51, Pic52, Pic53
  ];

  return (
    <>
      {/* ---------------- HERO SECTION ---------------- */}
      <header className="hero">
        <div className="container hero-wrapper">

          <div className="hero-left">
            <p className="hero-subtitle">WELCOME TO LAXMI MULTISPECIALITY HOSPITAL</p>

            <h1 className="hero-title">
              Delivering Comprehensive <br />
              Healthcare Services <br />
              To Our Community
            </h1>

            <button className="hero-btn">
              <a href="/about-us" className="home-jp-toggle">
                Read More <span className="opd-plus">+</span>
              </a>
            </button>
          </div>

          <div className="hero-right">
            <h2 className="opd-title">OPD TIMINGS</h2>

            <div className="opd-list">
              {[
                ["Monday", "09:00 AM - 08:00 PM"],
                ["Tuesday", "09:00 AM - 08:00 PM"],
                ["Wednesday", "09:00 AM - 08:00 PM"],
                ["Thursday", "09:00 AM - 08:00 PM"],
                ["Friday", "09:00 AM - 08:00 PM"],
                ["Saturday", "09:00 AM - 08:00 PM"],
                ["Sunday", "Emergency"],
              ].map(([day, time], i) => (
                <div className="opd-row" key={i}>
                  <span>{day}</span>
                  <span>{time}</span>
                </div>
              ))}
            </div>

            <button className="opd-btn">
              Book Appointment <span className="opd-plus">+</span>
            </button>
          </div>
        </div>
      </header>

      {/* ---------------- STATS SECTION ---------------- */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-sub">
            {statsData.map((stat, index) => (
              <div className="stat-box" key={index}>
                <span className="stats-count">{stat.count}</span><br />
                <span className="stats-je">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="services-section">
        <div className="container">
          <span className="services-title">— Our Key Services —</span>
          <div className="services-container">
            {servicesData.map((service, idx) => (
              <Link
                to={service.link}
                key={idx}
                className="services-card-link"
              >
                <div className="services-card">
                  <div className="services-icon">
                    <img src={service.img} alt={service.title} />
                  </div>

                  <h3>{service.title}</h3>

                  {service.desc && <p>{service.desc}</p>}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------------------------------------------- */}
      {/* ✅ MERGED HOSPITAL FEATURES SECTION (Your New Code) */}
      {/* ---------------------------------------------------- */}

      <section className="hospital-wrapper">
        <div className="container">
          <div className="hospital-features-je">
            <div className="features-left">
              <div className="features-grid-jp">

                <div className="feature-card">
                  <img src={emergency} alt="Emergency Service" />
                  <h3>Emergency Service</h3>
                  <p>For critical needs, receive immediate care.</p>
                </div>

                <div className="feature-card">
                  <img src={licensed} alt="Licensed & Insured" />
                  <h3>Licensed & Insured</h3>
                  <p>We are licensed and insured for safety & trust.</p>
                </div>

                <div className="feature-card">
                  <img src={support} alt="Available 24/7" />
                  <h3>Available 24/7</h3>
                  <p>We are here around the clock for you.</p>
                </div>

                <div className="feature-card">
                  <img src={bio} alt="Biomedical Waste" />
                  <h3>Biomedical Waste Management</h3>
                  <p>Committed to responsible waste disposal.</p>
                </div>
              </div>
            </div>

            <div className="features-right">
              <h2>
                What defines <br />
                <span>LAXMI MULTISPECIALITY HOSPITAL ?</span>
              </h2>

              <p>
                At LAXMI MULTISPECIALITY HOSPITAL, we provide modern facilities, advanced surgical treatments,
                and an experienced medical team.
              </p>

              <p>
                Our hospital family is dedicated to your care with best-class treatment.
              </p>

              <p>
                Awarded “Best Multispecialty Hospital in Gujarat” (Brands Impact 2022).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- DOCTOR CALL SECTION ---------------- */}
      <section className="doctor-call-section">
        <div className="container">
          <div className="call-doc-je">
            <div className="doctor-call-left">
              <div className="call-icon"><FaPhoneAlt /></div>
              <div className="call-text">
                <h3>
                  Need a Doctor for Checkup? Call for an emergency service. <br />
                  <span>available 24 hours</span>
                </h3>
              </div>
            </div>
            <div className="doc-btn-emer">
              <a href="tel:+918480801010">
                BOOK APPOINTMENT <span className="emer-plus">+</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- TEAM SECTION ---------------- */}
      <section className="team-section">
        <div className="container">
          <span className="team-subtitle">— TEAM —</span>
          <h2 className="team-title">Our Medical Team</h2>
          <div className="team-container">
            {doctors.map((doctor, index) => (
              <div className="team-card" key={index}>
                <img src={doctor.img} alt="Doctor" />
                <h3>{doctor.name}</h3>
                <p>{doctor.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- PARTNERS SLIDER ---------------- */}
      <div className="partners-slider">
        <div className="container">
          <div className="cashless-treat-head">
            <span>— CASHLESS TREATMENT —</span>
          </div>

          <div className="partners-track">
            {[...partnerImages, ...partnerImages].map((pic, i) => (
              <img key={i} src={pic} alt="Insurance Partner" />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
